<template>
  <div class="home-container">
    <statistics-vue />
    <abnormal-vue />
    <order-vue />
    <order1-vue />
    <line-graph-vue />
    <line-graph-1-vue />
  </div>
</template>

<script>
import abnormalVue from './component/abnormal.vue'
import lineGraphVue from './component/lineGraph.vue'
import lineGraph1Vue from './component/lineGraph1.vue'
import orderVue from './component/order.vue'
import order1Vue from './component/order1.vue'
import statisticsVue from './component/statistics.vue'
export default {
  name: 'Home',
  components: { statisticsVue, abnormalVue, orderVue, order1Vue,lineGraphVue ,lineGraph1Vue},
  data() {
    return {
      orderType: 1, //订货金额 2秒杀订单 3 积分订单
      orderToday: 2, //2 本周 3 本月
    }
  },
  created() {

  },
  methods: {
    //订单类型
    handleOrderType(type) {
      this.orderType = type
    },
    handleOrderToday(type) {
      this.orderToday = type
    }
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  padding: 20px;
}
</style>
